import { render, staticRenderFns } from "./BadRequestContent.vue?vue&type=template&id=5b4df74f&scoped=true"
import script from "./BadRequestContent.vue?vue&type=script&lang=js"
export * from "./BadRequestContent.vue?vue&type=script&lang=js"
import style0 from "./BadRequestContent.vue?vue&type=style&index=0&id=5b4df74f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4df74f",
  null
  
)

export default component.exports